export default "__VITE_ASSET__XBumTzGOaYHEgyOcLsPpcQ__"